import React from 'react';
import { useTwoForOneContext } from './TwoForOneContext';
import ReactModal from 'react-modal';
import { getOr } from '@/utils/options';
import CouponCard from '../CouponCard';
import { SMSResponseState } from './Utils';
import FooterSection from './FooterSection';

const ModalCard = () => {
  const { activeCard, setActiveCard } = useTwoForOneContext();
  const [phoneNumber, setPhoneNumber] = React.useState<string | null>(null);
  const [state, setState] = React.useState<SMSResponseState | null>(null);

  const handlePhoneNumberChange = (value: string) => {
    setState(null);
    if (value === '') {
      return setPhoneNumber(null);
    }
    //Remove non digit characters
    return setPhoneNumber(value.replace(/\D/g, ''));
  };

  const clearData = () => {
    setActiveCard(null);
    setPhoneNumber(null);
    setState(null);
  };

  //This is needed so screen readers don't see main content when modal is opened.
  React.useEffect(() => {
    ReactModal.setAppElement('body');
  }, []);

  return (
    <ReactModal
      isOpen={Boolean(activeCard)}
      onRequestClose={() => clearData()}
      contentLabel={'title'}
      htmlOpenClassName="overflow-hidden"
      overlayClassName={'z-[100] flex fixed inset-0 justify-center items-center bg-[#000]/20 p-16 lg:p-32'}
      className="relative max-h-full max-w-xl overflow-y-auto rounded-28 outline-none lg:max-w-3xl"
    >
      <CouponCard
        subTitle={activeCard?.companyName}
        title={getOr(activeCard?.title, '')}
        link={activeCard?.companyLink}
        phoneNumber={activeCard?.phoneNumber}
        onClose={() => clearData()}
        onPhonenumberChange={(value) => handlePhoneNumberChange(value)}
        infoText="Aðeins er hægt að virkja tilboð einu sinni á hvert símanúmer"
        state={state}
        footerSection={
          <FooterSection
            phoneNumber={getOr(phoneNumber, '')}
            companyName={getOr(activeCard?.companyName, '')}
            codeQuantity={activeCard?.codeQuantity || 1}
            messageText={activeCard?.messageText || undefined}
            providerCode={activeCard?.providerCode || undefined}
            saleInfo={getOr(activeCard?.title, '')}
            state={state}
            setState={setState}
          />
        }
      />
    </ReactModal>
  );
};
export default ModalCard;
